import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import Button from '@prisjakt/ui-button';
import Clickable from '@prisjakt/ui-clickable';
import { colors, layout } from '@prisjakt/ui-base';

export const OptionList = styled.ul`
  list-style: none;
  margin: ${layout.measurements.spacing025} 0 0 0;
`;

export const ShowMoreButton = styled.button``;

export const LoaderWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
`;

export const Name = styled.span.attrs({ 'data-test': 'FilterOptionName' })`
  width: 100%;
  padding-right: ${layout.measurements.spacing025};
`;

type OptionProps = {
  selected?: boolean;
  disabled?: boolean;
};

export const Count = styled.span.attrs({ 'data-test': 'FilterOptionCount' })`
  opacity: 0.8;
  background-color: ${colors.backgroundLightGray};
  padding: ${layout.measurements.spacing025};
  color: ${p => p.theme.colors.base700};
  border-radius: 2px;
`;

export const IconButton = styled(Button)<{ isOpen: boolean }>`
  transform: scaleY(${({ isOpen }) => (isOpen ? 1 : -1)});
  transition: transform 0.15s ease-in-out;
  height: auto;
  width: auto;
`;

export const OptionListItem = styled.li<OptionProps>`
  display: flex;
  /* Option / Clickable is wrapped in a span with no styling */
  > *[data-test='InternalLink'] {
    flex: 1;
  }
  opacity: ${ifProp({ disabled: true }, 0.3, 1)};
  pointer-events: ${ifProp({ disabled: true }, 'none', 'auto')};
`;

export const Option = styled(Clickable).attrs({
  'data-test': 'FilterOption',
})<OptionProps>`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  text-align: left;
  width: 100%;
  padding: 1px ${layout.measurements.spacing100};

  &.focus-visible,
  &:hover {
    color: ${({ theme }) => theme.text.callToActionHover};
  }
  ${props =>
    props.selected &&
    css`
      border: 1px solid ${props.theme.colors.maybeBlue700};
      border-radius: ${layout.borderRadius};
    `}
`;

export const ExpandingCheckboxOption = styled(Option)`
  padding: 1px 0;
  padding-right: ${layout.measurements.spacing025};
  opacity: ${ifProp({ disabled: true }, 0.3, 1)};
`;

const INPUT_BORDER = css`
  border: 1px solid ${colors.borderDarkGray};
`;

type CheckboxProps = {
  checked?: boolean;
};

export const Checkbox = styled.div<CheckboxProps>`
  margin-right: ${layout.measurements.spacing050};
  display: flex;
  background: ${p => p.theme.colors.base0};
  ${INPUT_BORDER}

  ${props =>
    props.checked &&
    css`
      background-color: ${props.theme.colors.maybeBlue700};
      border: 1px solid ${props.theme.colors.maybeBlue700};
    `}
`;

type RadioButtonProps = {
  checked?: boolean;
};

export const RadioButton = styled.div<RadioButtonProps>`
  display: inline-block;
  vertical-align: top;
  margin-left: 2px;
  margin-top: 2px;
  margin-right: 10px;
  width: 16px;
  min-width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${p => p.theme.colors.base0};
  ${INPUT_BORDER}
  ${props =>
    props.checked &&
    css`
      background-color: ${props.theme.colors.base0};
      box-shadow: 0 0 0 1px ${props.theme.colors.base300};
      border: 5px solid ${props.theme.colors.maybeBlue700};
      color: ${props.theme.colors.base700};
    `}
`;

export const Divider = styled.hr`
  border-color: ${colors.borderLightGray};
`;
